/*
 * Copyright © 2026 MS IMAGES. All rights reserved.
 * Proprietary and confidential — unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */

/**
 * SuperAdminLayout
 *
 * Wraps SuperAdmin routes with ModuleShell + SuperAdminSidebarContent.
 * Used as a route layout element for /superadmin/* routes.
 */

import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { ModuleShell } from './module-shell';
import { SuperAdminSidebarContent } from './Sidebar';
import i18n from '@/lib/i18n';

export function SuperAdminLayout() {
  // Preload platform namespace for SuperAdmin routes
  useEffect(() => { i18n.loadNamespaces('platform'); }, []);

  return (
    <>
      <ModuleShell moduleId="admin">
        <SuperAdminSidebarContent />
      </ModuleShell>
      <div className="superadmin-content">
        <Outlet />
      </div>
      <style>{`
        .superadmin-content {
          padding: 24px 32px;
          width: 100%;
          box-sizing: border-box;
        }
        @media (max-width: 768px) {
          .superadmin-content {
            padding: 16px;
          }
        }
      `}</style>
    </>
  );
}
